import moment from "moment-timezone";
import { weekDayToFullWeekName } from "../pages/personal/JournalPage";

export default function generateLessonsSchedule(lessons, student, timeZone) {
    const studentsFutureLessons = lessons.filter(el => 
        (el.student_id === student.studentId || el.student_id === student.id)
        && moment.utc(el.start_time).tz(timeZone).isAfter(moment().tz(timeZone)) 
        && el.not_scheduled !== true
    );
    const lessonsScheduleArr = studentsFutureLessons.map(el => {
        let startTime = moment.utc(el.start_time).tz(timeZone);
        let endTime = moment.utc(el.end_time).tz(timeZone);
        let weekday = moment.utc(el.start_time).tz(timeZone).isoWeekday();
        
        return {
            weekDay: weekDayToFullWeekName(weekday).full,
            weekDayShort: weekDayToFullWeekName(weekday).short,
            time: `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")} - ${el.quantity} занятий`,
            startTime: startTime.toISOString(),
        }
    });
    const lessonsScheduleResult = lessonsScheduleArr.filter((value, index, self) =>
        index === self.findIndex((t) => (
            t.weekDay === value.weekDay && t.time === value.time
        ))
    )
    console.log("studetsFutureLessons", studentsFutureLessons);
    console.log("lessonsScheduleArr", lessonsScheduleArr);
    console.log("lessonsScheduleResult", lessonsScheduleResult);
    return lessonsScheduleResult;
}
